import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=43807b12&scoped=true&"
import script from "./lista.vue?vue&type=script&lang=ts&"
export * from "./lista.vue?vue&type=script&lang=ts&"
import style0 from "./lista.vue?vue&type=style&index=0&id=43807b12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43807b12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItemGroup,VRow})
